import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => {
    const unit = theme.spacing();
    return {
        root: {
            margin: 0,
            padding: `${unit * 3}px ${unit * 3}px ${unit}px`,
            flex: '0 0 auto',
        },
    };
};

const BoxTitle = ({ classes, className, disableTypography, children }) => (
    <div className={classNames(classes.root, className)}>
        {disableTypography ? (
            children
        ) : (
            <Typography variant="h6">{children}</Typography>
        )}
    </div>
);

BoxTitle.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    disableTypography: PropTypes.bool,
};

BoxTitle.defaultProps = {
    disableTypography: false,
};

export default withStyles(styles)(BoxTitle);
